import { render, staticRenderFns } from "./AddPPM_yearly.vue?vue&type=template&id=533229ae&scoped=true"
import script from "./AddPPM_yearly.vue?vue&type=script&lang=ts"
export * from "./AddPPM_yearly.vue?vue&type=script&lang=ts"
import style0 from "./AddPPM_yearly.vue?vue&type=style&index=0&id=533229ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533229ae",
  null
  
)

export default component.exports